/**
 * Bildirim silme kuralları — backend 409 yanıtlarıyla uyumlu.
 * Zamanlanmış: önce iptal, sonra sil. Gönderilmiş: silinemez.
 */

export function getNotificationDeleteInfo(notification) {
  if (!notification) {
    return {
      canOpenModal: false,
      canDelete: false,
      message: 'Bildirim bulunamadı',
    };
  }

  const status = notification.status;

  if (status === 'sent') {
    return {
      canOpenModal: false,
      canDelete: false,
      message: 'Gönderilmiş bildirimler silinemez. Gönderim kaydı olarak saklanır.',
    };
  }

  if (status === 'sending') {
    return {
      canOpenModal: false,
      canDelete: false,
      message: 'Gönderilmekte olan bildirim silinemez.',
    };
  }

  if (status === 'scheduled') {
    return {
      canOpenModal: true,
      canDelete: true,
      requiresCancelFirst: true,
      confirmLabel: 'İptal Et ve Sil',
      modalTitle: 'Zamanlanmış Bildirimi Sil',
      modalDescription:
        'Bu bildirim zamanlanmış durumda. Silmek için önce zamanlama iptal edilecek, ardından kayıt silinecek.',
    };
  }

  return {
    canOpenModal: true,
    canDelete: true,
    requiresCancelFirst: false,
    confirmLabel: 'Sil',
    modalTitle: 'Bildirimi Sil',
    modalDescription: null,
  };
}

export function parseNotificationDeleteError(errorOrPayload, fallback = 'Bildirim silinemedi') {
  if (typeof errorOrPayload === 'string' && errorOrPayload.trim()) {
    return errorOrPayload;
  }
  if (!errorOrPayload) return fallback;

  const status = errorOrPayload.response?.status || errorOrPayload.status;
  const data = errorOrPayload.response?.data || errorOrPayload;

  if (status === 409) {
    return (
      data?.message ||
      data?.error ||
      data?.note ||
      'Bu bildirim mevcut durumda silinemez. Zamanlanmış bildirimler için önce iptal edin; gönderilmiş bildirimler silinemez.'
    );
  }

  return (
    data?.message ||
    data?.error ||
    data?.note ||
    errorOrPayload.message ||
    fallback
  );
}
